import { Box, Typography } from '@mui/material';
import { ThemePalette } from 'mui.theme';
import { FlexBox } from 'components/Containers/FlexBox';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Customized,
} from 'recharts';
import type { GroupedHistogramDataItem } from 'types/FleetOverview.types';
import { transformData, calculateAverage } from 'views/FleetComparison/helper';

export const MetricItemChartTrends = ({
  enableDarkTheme,
  data,
  colorIndex,
  bumperIdMap,
}: {
  enableDarkTheme: boolean;
  data: GroupedHistogramDataItem[];
  colorIndex: string[];
  bumperIdMap: string[];
}) => {
  const transformedData = transformData(data);
  const movingAverage = calculateAverage(transformedData);
  return (
    <Box
      sx={{
        textAlign: 'left',
        margin: '20px',
        paddingLeft: '20px',
        paddingTop: '20px',
        border: '1px solid #26364C',
        borderRadius: '4px',
      }}
    >
      <Typography>Daily Moving Average</Typography>
      <FlexBox
        sx={{
          justifyContent: 'center',
          alignItems: 'center',
          maxWidth: 'inherit',
          height: '500px',
          flexDirection: 'column',
          paddingTop: '20px',
          marginRight: '10px',
          paddingBottom: '10px',
        }}
        id="vehicle-status-page"
      >
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            width={500}
            height={300}
            data={movingAverage}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <Customized component={CustomBackground} />
            <CartesianGrid
              strokeDasharray="3 3"
              stroke={ThemePalette.dark.cartesianGrid}
              vertical={false}
            />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            {bumperIdMap.map((itemMap, index) => (
              <Line
                key={itemMap}
                type="linear"
                dataKey={itemMap}
                stroke={colorIndex[index]}
              />
            ))}
          </LineChart>
        </ResponsiveContainer>
      </FlexBox>
    </Box>
  );
};

const CustomBackground = (props: any) => {
  const { height, width } = props;
  const colors = ['#EB9191', '#FDFF9B', '#A2E1AA'];
  const sectionHeight = (height - 3) / colors.length;

  return (
    <g>
      {colors.map((color, index) => (
        <rect
          key={index}
          x={0}
          y={index * sectionHeight}
          width={width}
          height={sectionHeight}
          fill={color}
          opacity={0.8}
        />
      ))}
    </g>
  );
};
